import { StrapiImage } from "types/image";

export const getStrapiImagePath = (image: StrapiImage | undefined) => {
  if (!image?.url) {
    // return placeholder image
    return "/hero.png";
  }
  return `${process.env.NEXT_PUBLIC_STRAPI_URL}${image.url}`;
};
